
import { EssayStatus } from 'domain/enums';

export interface EssayViewModel {
    readonly EssayId: number;
    readonly Text: string | null;
    readonly Title: string;
    readonly Rating: number | null;
    readonly TimeLimitStr: string | null;
    readonly TimeLimitMinutes: number | null;
    readonly StartedAt: number | null;
    readonly FinishedAt: number | null;
    readonly CreatedAt: number;
    readonly UpdatedAt: number;
    readonly Status: EssayStatus;
    readonly StatusStr: string;
    readonly StudentName: string;
    readonly TeacherName: string;
    readonly TeacherComment: string;
    readonly StudentSaveAllowed: boolean;
    readonly StudentSubmitAllowed: boolean;
    readonly TeacherAcceptAllowed: boolean;
    readonly TeacherRejectAllowed: boolean;
    readonly Instructions: string;
}

export class EssayStudentSubmitViewModel {
    constructor(readonly EssayId: number, readonly Text: string) {

    }
}

export class EssayStudentSaveViewModel {
    constructor(readonly EssayId: number, readonly Text: string) {

    }
}

export class EssayTeacherSubmitViewModel {
    constructor(readonly EssayId: number, readonly Text: string, readonly Accept: boolean, readonly Rating: number | null, readonly Comment: string | null) {

    }
}

export interface EssayTeacherListResponseItem {
    readonly EssayId: number;
    readonly Title: string;
    readonly StudentName: string;
    readonly Status: EssayStatus;
    readonly StatusStr: string;
    readonly CreatedAt: number;
    readonly UpdatedAt: number;
    readonly Rating: number | null;
}

export interface EssayTeacherListResponse {
    readonly Items: EssayTeacherListResponseItem[];
    readonly AllItemsCount : number;
}

export class EssayCreateViewModel {
    constructor(readonly ClassRoomId: number, readonly Title: string, readonly TimeLimit: string | null = null, readonly Instructions: string | null = null) { }
}

export interface ExamStudentListResponseItem {
    readonly ExamId: number;
    readonly TeacherName: string;
    readonly Status: EssayStatus;
    readonly StatusStr: string;
    readonly CreatedAt: number;
    readonly UpdatedAt: number;
    readonly TimeLimitMinutes: number | null;
}

export interface ExamStudentListResponse {
    readonly Items: ExamStudentListResponseItem[];
    readonly AllItemsCount: number;
}

export interface EssayListDto {
    Filter: string[];
    FilterDate: string | null;
    Page?: number;
}

export const EssayStatuses = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5'
] as const;
export type EssaysStatus = typeof EssayStatuses[number];

export const EssayLabels: { readonly [K in EssaysStatus]: string } = {
    '0': 'None',
    '1': 'New',
    '2': 'InProgress',
    '3': 'Done',
    '4': 'Accepted',
    '5': 'Rejected',
};

